import { prayerRamadanFr } from './golf4App.fr.js';
// Frans (fr-FR), weatherPrayer: zelfde vorm als weatherPrayer.nl.ts. Tu-vorm; voor kinderen positief
// en concreet, nooit bang maken. NEUTRAAL: in geo (behalve de gebedsvarianten) en weather.* nooit
// prière, mosquée of het woord voor de oproep. De oproep ({call}: ezan, adhan) is mannelijk en
// begint met een klinker: altijd "l’{call}". Ophalen/uploaden = importer (niet télécharger).
export const weatherPrayerFr = {
    geo: {
        title: 'Lieu',
        intro: 'Choisis le code postal ou la ville de ta famille. Nous gardons seulement une zone d’environ un kilomètre.',
        searchLabel: 'Code postal ou ville',
        searchPlaceholder: 'Par exemple 3511 AA ou Utrecht',
        searchButton: 'Chercher',
        searchHint: 'Pas besoin de numéro de maison ; nous ne l’envoyons pas non plus.',
        noResults: 'Rien trouvé. Essaie un code postal ou un nom de ville.',
        tooMany: 'Doucement : réessaie dans une minute.',
        chosen: 'Zone : {label}',
        privacy: 'Nous ne gardons ni rue, ni numéro, ni endroit précis. La famille éloignée associée, les invités et les liens d’agenda ne le voient jamais.',
        remove: 'Effacer le lieu',
        removed: 'Lieu effacé.',
        variants: {
            weather: {
                settingsBody: 'Pour la météo sur le tableau',
                why: 'Pourquoi ? Pour la météo sur le tableau. Pour rien d’autre.',
                removeConfirm: 'Nous effaçons le lieu de ta famille et des tablettes. La météo s’arrête alors jusqu’à ce que tu en choisisses un nouveau. Continuer ?',
                askBody: 'Une seule fois, pour la météo. Nous gardons seulement une zone d’environ un kilomètre.',
            },
            prayer: {
                settingsBody: 'Pour les heures de prière',
                why: 'Pourquoi ? Pour les heures de prière. Pour rien d’autre.',
                removeConfirm: 'Nous effaçons le lieu de ta famille et des tablettes. Les heures de prière s’arrêtent alors jusqu’à ce que tu en choisisses un nouveau. Continuer ?',
                askBody: 'Une seule fois, pour les heures sur le tableau. Nous gardons seulement une zone d’environ un kilomètre.',
            },
            both: {
                settingsBody: 'Pour la météo et les heures de prière',
                why: 'Pourquoi ? Pour la météo sur le tableau et les heures de prière. Pour rien d’autre.',
                removeConfirm: 'Nous effaçons le lieu de ta famille et des tablettes. La météo et les heures de prière s’arrêtent alors jusqu’à ce que tu en choisisses un nouveau. Continuer ?',
                askBody: 'Une seule fois, pour la météo et les heures sur le tableau. Nous gardons seulement une zone d’environ un kilomètre.',
            },
        },
        device: {
            title: 'Lieu de cette tablette',
            household: 'Comme la famille',
            own: 'Utiliser la position de cette tablette',
            ownHint: 'Pratique si cette tablette est ailleurs, par exemple dans une maison de vacances.',
            otherHome: 'La tablette est chez quelqu’un d’autre ? Nous gardons alors aussi une zone d’environ un kilomètre autour de cette maison. Préviens la personne.',
            pending: 'Une question s’affiche sur la tablette. Touche « Oui, une seule fois ».',
            measured: 'Zone de cette tablette : {label}',
            far: 'Cette tablette est à environ {km} km de l’adresse de ta famille.',
            remeasure: 'Déterminer à nouveau',
            failed: 'La tablette n’a pas pu déterminer sa position. Nous utilisons le lieu de la famille.',
        },
        kiosk: {
            askTitle: 'Cette tablette peut-elle utiliser sa position ?',
            yes: 'Oui, une seule fois',
            no: 'Non',
            busy: 'Recherche…',
            done: 'C’est fait : {label}',
            failed: 'Ça n’a pas marché. Nous utilisons le lieu de la famille.',
        },
        web: {
            choose: 'Choisir un lieu',
            change: 'Changer de lieu',
            none: 'Aucun lieu choisi.',
            area: 'Zone : {label}',
            tablets: 'Tablettes',
            tabletsNone: 'Aucune tablette associée pour l’instant.',
            edit: 'Modifier',
            save: 'Enregistrer',
            saved: 'Enregistré',
            cancel: 'Annuler',
            country: 'Pays',
            countryNl: 'Pays-Bas',
            countryOther: 'Autre pays',
            city: 'Ville',
            postcode: 'Code postal',
            countryCode: 'Code pays (p. ex. BE ou DE)',
            searching: 'Recherche…',
            pick: 'Choisis ta zone',
            removeTitle: 'Effacer le lieu ?',
            unavailable: 'La recherche ne marche pas pour l’instant. Réessaie plus tard.',
            requested: 'Mesure demandée',
            deviceSame: 'Comme la famille',
            deviceSameWith: 'Comme la famille ({label})',
        },
        credits: {
            pdok: 'Données de localisation : PDOK/Kadaster',
            osm: '© contributeurs OpenStreetMap (ODbL)',
        },
    },
    weather: {
        title: 'Météo',
        settingsBody: 'Manteau, bottes ou crème solaire ? Des conseils pour les moments où les enfants sortent',
        enabled: 'Afficher la météo',
        needsLocation: 'Choisis d’abord un lieu, et nous afficherons la météo.',
        showInBanners: 'Dans l’alerte de départ (« À 8:15 pour l’école : imperméable et bottes »)',
        adjust: 'Ajuster',
        morning: 'Le matin va de {start} à {end}',
        thresholdsTitle: 'Quel conseil, et quand',
        thresholdsNote: 'Soleil, chaleur, vent et verglas suivent le RIVM et le KNMI. Les seuils pour les manteaux et les pulls sont nos réglages par défaut : adapte-les librement.',
        thresholds: {
            sweaterBelowC: 'Gilet ou pull en dessous de {value} °C (ressenti)',
            coatBelowC: 'Manteau en dessous de {value} °C',
            thickCoatBelowC: 'Gros manteau en dessous de {value} °C',
            hatGlovesAtOrBelowC: 'Bonnet et gants à {value} °C et en dessous',
            umbrella: 'Proposer le parapluie quand il pleut et qu’il y a peu de vent',
            shortsFromC: 'Short possible à partir de {value} °C et au sec',
            waterBottleFromC: 'Gourde à emporter à partir de {value} °C',
        },
        perChild: 'Par enfant',
        coldDelta: {
            label: 'A vite froid',
            value: {
                one: 'Manteau {count} degré plus tôt',
                other: 'Manteau {count} degrés plus tôt',
            },
            warmer: {
                one: 'Manteau {count} degré plus tard',
                other: 'Manteau {count} degrés plus tard',
            },
            none: 'Comme tout le monde',
            hint: 'Un enfant a vite froid ? Augmente le chiffre : il aura son manteau autant de degrés plus tôt. Plus bas : plus tard.',
        },
        uvClearSky: 'Indice UV {value} (par ciel dégagé)',
        uvCloud: 'Indice UV {value}',
        feelsLike: 'Ressenti {value} °C',
        wind: 'Vent {bft} Beaufort',
        stale: 'Météo inconnue pour l’instant',
        attribution: 'Données météo : MET Norway',
        feel: { cold: 'froid', chilly: 'frais', mild: 'doux', warm: 'chaud', hot: 'très chaud' },
        itemLabels: {
            warning: 'Attention',
            thunder: 'Orage',
            very_windy: 'Vent très fort',
            slippery: 'Glissant',
            very_cold: 'Très froid',
            thick_coat: 'Gros manteau',
            coat: 'Manteau',
            sweater: 'Gilet ou pull',
            raincoat: 'Imperméable',
            boots: 'Bottes',
            hat_gloves: 'Bonnet et gants',
            no_umbrella: 'Capuche',
            umbrella: 'Parapluie',
            windy: 'Vent',
            shade: 'À l’ombre',
            sunscreen: 'Crème solaire',
            sun_hat: 'Casquette',
            extra_drinks: 'Boire beaucoup',
            water_bottle: 'Gourde',
            midday_shade: 'Ombre',
            reapply: 'Encore de la crème',
            shorts: 'Short',
        },
        itemWords: {
            warning: 'attention',
            thunder: 'on rentre quand ça gronde',
            very_windy: 'vent très fort : bien tenir le guidon à vélo',
            slippery: 'ça peut glisser : marcher et rouler doucement',
            very_cold: 'très froid : pas longtemps dehors',
            thick_coat: 'gros manteau',
            coat: 'manteau',
            sweater: 'gilet ou pull',
            raincoat: 'imperméable',
            boots: 'bottes',
            hat_gloves: 'bonnet et gants',
            no_umbrella: 'pas de parapluie, capuche sur la tête',
            umbrella: 'parapluie',
            windy: 'vent fort : attention à vélo',
            shade: 'à l’ombre',
            sunscreen: 'crème solaire',
            sun_hat: 'casquette',
            extra_drinks: 'boire beaucoup et jouer au calme à l’ombre',
            water_bottle: 'gourde à emporter',
            midday_shade: 'jouer à l’ombre entre midi et 15 h',
            reapply: 'remettre de la crème à midi',
            shorts: 'short possible',
        },
        waterproof: 'gros manteau imperméable',
        headline: {
            rain: 'À {time}, il pleut : {items}.',
            wet: 'Ce matin, ça peut être mouillé : {items}.',
            wetLater: 'Vers {time}, ça peut être mouillé : {items}.',
            snow: 'À {time}, il neige : {items}.',
            thunder: 'À {time}, il peut y avoir de l’orage : on rentre quand ça gronde.',
            cold: 'Froid dehors à {time} : {items}.',
            hot: 'Il va faire chaud : {items}.',
            coolThenWarm: 'Frais à {time}, chaud plus tard : {items}.',
            sun: 'Du soleil : {items}.',
            wind: 'Vent fort à {time} : attention à vélo.',
            nice: 'À {time} : temps {feel}.',
            niceWith: 'À {time} : temps {feel}, {items}.',
            warning: '{kids}',
            departure: 'À {time}, départ pour {title} : {items}.',
        },
        and: 'et',
        warningKids: {
            wind: 'Il y a beaucoup de vent. Ferme bien ton manteau et marche près de papa ou maman.',
            rain: 'Il pleut beaucoup. Mets ton imperméable et prends tes bottes.',
            thunder: 'Il peut y avoir de l’orage. Quand ça gronde, on rentre.',
            snow: 'Il neige beaucoup. Mets tes bottes et marche doucement.',
            ice: 'Ça glisse dehors. Marche doucement, ne cours pas.',
            heat: 'Il fait très chaud. Bois beaucoup et joue à l’ombre.',
            cold: 'Il fait très froid. Habille-toi chaudement : bonnet et gants.',
            fog: 'Il y a du brouillard. Reste près de papa ou maman.',
            other: 'Aujourd’hui, fais bien attention à la météo.',
        },
        warningLevel: { yellow: 'Code jaune', orange: 'Code orange', red: 'Code rouge' },
        web: {
            todayTitle: 'Météo du jour',
            todayTitleAt: 'Météo du jour · {label}',
            tomorrowTitle: 'Météo de demain',
            tomorrowTitleAt: 'Météo de demain · {label}',
            nowLabel: 'Maintenant',
            tomorrowLabel: 'Demain',
            invite: 'Tu veux des conseils météo sur le tableau ?',
            inviteBody: 'Manteau, bottes ou crème solaire : nous le disons aux moments où les enfants sortent.',
            notNow: 'Pas maintenant',
            chooseLocation: 'Choisir un lieu',
            settings: 'Réglages',
            showOnKiosk: 'Sur le tableau',
            save: 'Enregistrer',
            saved: 'Enregistré',
            resetDefaults: 'Rétablir les valeurs par défaut',
            morningStart: 'Matin à partir de',
            morningEnd: 'Matin jusqu’à',
            alsoFor: '{name} : {items}',
            everyone: 'Tout le monde',
            tempNow: '{temp}°',
            staleBody: 'Nous récupérons la météo dès que possible.',
            childNone: 'Pas encore d’enfants dans la famille.',
            offTitle: 'Désactiver la météo ?',
            offConfirm: 'Rien d’autre n’utilise le lieu. Nous effaçons donc aussi le lieu de ta famille et des tablettes. Continuer ?',
            offConfirmButton: 'Désactiver et effacer le lieu',
            offNotice: 'La météo est désactivée.',
            offNoLocation: 'La météo est désactivée. Choisis un lieu ; tu pourras ensuite l’activer ici d’une seule touche.',
            turnOn: 'Activer la météo',
            less: 'Moins',
            more: 'Plus',
        },
        warningSource: {
            knmi: 'Source : KNMI',
            meteoalarm: 'Source : KNMI via MeteoAlarm',
            fake: 'Source : test',
        },
        /** Précipitations au-dessus du graphique du widget Précipitations. */
        precip: {
            dryAll: 'Sec pendant les {hours} prochaines heures.',
            nowUntil: 'En ce moment {kind}, sec à {end}.',
            nowLong: '{kind} pendant les prochaines heures.',
            fromUntil: '{kind} à partir de {start}, sec à {end}.',
            dryUntil: 'Sec jusqu’à {start}, puis {kind}.',
            words: {
                drizzle: 'bruine',
                rain_light: 'pluie faible',
                rain: 'pluie',
                rain_heavy: 'forte pluie',
                sleet: 'neige fondue',
                snow: 'neige',
                hail: 'grêle',
                thunder: 'averses orageuses',
            },
        },
    },
    prayer: {
        // Golf 4: Ramadan op het bord (DESIGN §8.GB.14).
        ramadan: prayerRamadanFr,
        title: 'Heures de prière',
        settingsBody: 'Les heures pour ta région, sur le tableau du salon',
        enabled: 'Utiliser les heures de prière',
        needsLocation: 'Choisis d’abord un lieu. Nous calculerons alors les heures pour ta région.',
        privacy: 'Ceci fait partie de « Ce qui convient à notre famille ». Seuls les parents voient les réglages ; la famille éloignée associée et les invités, jamais.',
        boardVisible: 'Attention : les heures et la carte s’affichent sur le tableau, donc tout le monde dans la pièce les voit (aussi les visiteurs ou une baby-sitter).',
        call: { turkish: 'ezan', arabic: 'adhan' },
        callTitle: { turkish: 'Ezan', arabic: 'Adhan' },
        setup: {
            quickTitle: 'Heures de prière',
            quickBody: 'Nous calculons avec {method}. Ça correspond à ta mosquée ? Alors c’est fini. Tu peux toujours ajuster les heures et le son de chaque prière.',
            quickNoCall: 'Il n’y a pas encore d’enregistrement de l’{call}. Tant que ta famille n’en a pas importé un, une sonnerie douce retentit sur la tablette du salon.',
            quickTone: 'Pour « Quel enregistrement ? », la sonnerie douce est choisie. Tu veux entendre l’{call} ? Choisis l’enregistrement fourni dans « Plus de réglages ».',
            quickTimes: 'Aujourd’hui à {place}',
            quickDone: 'Fini',
            quickMore: 'Plus de réglages',
            step1: 'Comment calculer les heures ?',
            step1Body: 'Les mosquées ne calculent pas toutes de la même façon. Choisis ce que ta mosquée utilise, ou garde notre choix.',
            step2: 'Ajuste selon ta mosquée',
            step2Body: 'Compare avec le calendrier de ta mosquée. Si une heure est différente, décale-la. En été, les mosquées ont parfois une demi-heure d’écart ou plus : règle alors mois par mois, ou importe le calendrier annuel.',
            step3: 'Qu’entend-on sur la tablette ?',
            step3Body: 'L’{call} retentit sur la tablette du salon. Les autres tablettes restent silencieuses, sauf si tu les actives.',
            step3BodyNoCall: 'Il n’y a pas encore d’enregistrement de l’{call}. Tant que ta famille n’en a pas importé un ci-dessous, c’est la sonnerie douce qui retentit pour « {callTitle} ». Les autres tablettes restent silencieuses, sauf si tu les actives.',
            step3BodyTone: 'Pour « {callTitle} », c’est la sonnerie douce qui retentit, car elle est choisie dans « {step4} ». Les autres tablettes restent silencieuses, sauf si tu les actives.',
            step4: 'Quel enregistrement ?',
            done: 'C’est prêt. La prochaine prière s’affiche maintenant sur le tableau.',
        },
        method: {
            diyanet: 'Diyanet (Turquie)',
            mwl: 'Ligue islamique mondiale',
            uoif: 'UOIF (France)',
            morocco: 'Maroc',
            jafari: 'Jafari (chiite)',
            eu_joint: 'Calendrier européen commun (Diyanet · Milli Görüş)',
        },
        methodInSentence: {
            diyanet: 'le calendrier de la Diyanet (Turquie)',
            mwl: 'la Ligue islamique mondiale',
            uoif: 'l’UOIF (France)',
            morocco: 'la méthode marocaine',
            jafari: 'la méthode jafari (chiite)',
            eu_joint: 'le calendrier européen commun (Diyanet · Milli Görüş)',
        },
        methodHint: {
            diyanet: 'Le calendrier de la Turquie. Les mosquées turques en Europe utilisent le calendrier européen ci-dessus.',
            mwl: 'Très utilisée en Europe. Un bon choix par défaut si tu ne sais pas.',
            uoif: 'Fajr plus tard et Isha plus tôt (12°).',
            morocco: 'Ce qu’utilisent souvent les mosquées marocaines.',
            jafari: 'Maghrib après le crépuscule, environ un quart d’heure après le coucher du soleil.',
            eu_joint: 'Depuis 2023, le même calendrier pour la Diyanet (ISN, DITIB) et Milli Görüş en Europe. Choisissez-le si votre mosquée est turque.',
        },
        asrSchool: {
            standard: 'Standard (première heure)',
            hanafi: 'Hanafite (plus tard dans l’après-midi)',
        },
        asrSource: {
            title: 'Heure de {asr}',
            madhab: 'Suit votre école',
            manual: 'Réglé par vous',
            unset: 'Par défaut',
            follow: 'Suivre à nouveau l’école',
            madhabLink: 'Choisir ou changer l’école',
            why: {
                hanafi: 'Vous suivez l’école hanafite : {asr} plus tard dans l’après-midi.',
                other_madhab: 'Vous suivez l’école {madhab} : {asr} à l’heure standard.',
                calendar: 'Vous suivez l’école hanafite. Le calendrier de Diyanet et de Milli Görüş donne pour {asr} la première heure (asr-ı evvel), comme votre mosquée. Vous préférez l’heure plus tardive (asr-ı sani) ? Choisissez « {hanafi} » ci-dessus.',
                no_madhab: 'Pas encore d’école choisie : {asr} à l’heure standard.',
            },
            manualWhy: 'Vous l’avez choisi vous-mêmes. Une autre école ne le change pas.',
        },
        madhabSuggestion: {
            body: 'Vous suivez l’école hanafite. Les mosquées turques en Europe calculent avec {method}.',
            apply: 'Utiliser ce calendrier',
            applied: 'Nous calculons maintenant avec {method}.',
        },
        naming: { turkish: 'Noms turcs', arabic: 'Noms arabes' },
        namingTitle: 'Noms des prières',
        names: {
            turkish: {
                fajr: 'Sabah',
                sunrise: 'Güneş',
                dhuhr: 'Öğle',
                asr: 'İkindi',
                maghrib: 'Akşam',
                isha: 'Yatsı',
            },
            arabic: {
                fajr: 'Fajr',
                sunrise: 'Lever du soleil',
                dhuhr: 'Dhuhr',
                asr: 'Asr',
                maghrib: 'Maghrib',
                isha: 'Isha',
            },
        },
        cardNames: {
            turkish: { fajr: 'Sabah', dhuhr: 'Öğle', asr: 'İkindi', maghrib: 'Akşam', isha: 'Yatsı' },
            arabic: { fajr: 'Fajr', dhuhr: 'Dhuhr', asr: 'Asr', maghrib: 'Maghrib', isha: 'Isha' },
        },
        sunriseNote: 'Le lever du soleil marque la fin du temps de {fajr}. Rien ne retentit à ce moment-là.',
        offsets: {
            title: 'Décalage par prière',
            sameAllYear: 'Pareil toute l’année',
            perMonth: 'Par mois',
            month: 'En {month}',
            later: '{value} min plus tard',
            earlier: '{value} min plus tôt',
            seeded: 'Ajusté sur le tableau Diyanet de Rotterdam, vérifié seulement pour septembre. Vérifie avec ta mosquée, surtout en été.',
            tableDay: 'Ces heures viennent du calendrier de ta mosquée. Les décalages ne s’appliquent qu’aux jours qui n’y figurent pas.',
            compare: 'Compare avec le calendrier de ta mosquée',
            dstCheck: 'L’heure a changé. Est-ce que ça correspond toujours au calendrier de ta mosquée ?',
            dstYes: 'Oui, c’est bon',
            dstAdjust: 'Ajuster',
        },
        table: {
            title: 'Importer le calendrier de ta mosquée',
            body: 'Colle le calendrier annuel (par ligne : date; {fajr}; lever du soleil; {dhuhr}; {asr}; {maghrib}; {isha}). Un jour du calendrier remplace notre calcul.',
            read: 'Importer',
            result: { one: '{count} jour importé', other: '{count} jours importés' },
            badLines: 'Illisible : ligne {lines}',
            fromTable: 'Du calendrier de ta mosquée',
            remove: 'Retirer le calendrier',
        },
        sound: {
            adhan: '{callTitle}',
            adhanPending: '{callTitle} (pas encore d’enregistrement : sonnerie pour l’instant)',
            adhanTone: '{callTitle} (sonnerie pour l’instant, voir « {step4} »)',
            chime: 'Sonnerie douce',
            silent: 'Silencieux (seulement la carte)',
        },
        yearRange: '{name} : en {month} vers {time}',
        fajrWarning: '{fajr} est avant le lever du soleil. L’{call} réveillerait alors toute la maison.',
        fajrNeedsRecording: 'Pour {fajr}, l’appel a sa propre formule (avec « as-salatu khayrun min an-nawm »), donc l’appel habituel ne retentit jamais à ce moment-là. Importe un enregistrement propre pour {fajr}, ou choisis la sonnerie.',
        quiet: {
            title: 'Le soir tard et la nuit',
            body: 'Après {from} et jusqu’à {until}, à la place de l’{call}, on entend :',
            chime: 'une sonnerie douce',
            silent: 'rien (seulement la carte au salon)',
            adhan: 'quand même l’{call}',
            hint: 'En juin, {isha} tombe vers minuit et {maghrib} après 22 h. Avec la sonnerie, la maison reste calme.',
        },
        /** Eenmalige melding na het overzetten naar de gezamenlijke kalender (0041). */
        methodNotice: 'Les horaires suivent désormais le calendrier européen de la Diyanet et de Milli Görüş ; en été, {fajr} et {isha} sont donc différents.',
        methodNoticeOk: 'D’accord',
        /** Eerlijk over eu_joint (gefit op de Diyanet-tabellen, niet officieel; review g6b fs r1). */
        methodApprox: 'Nous recalculons nous-mêmes le calendrier commun. Pour Rotterdam et Amsterdam, l’écart avec le tableau publié reste de 1 ou 2 minutes toute l’année. Aucune heure de prière et aucun adhan sur la tablette ne vient avant le tableau de la Diyanet : nous arrondissons vers le haut, et pour {fajr} nous ajoutons 2 minutes, 10 de mi-avril à mi-septembre. L’imsak, le début du jeûne, n’est en revanche jamais plus tard que le tableau ; pendant le Ramadan, le tableau affiche l’imsak et {fajr}. Ailleurs, surtout de mi-avril à mi-septembre, votre mosquée peut différer de quelques minutes (jusqu’à environ 9). Ajustez selon votre mosquée, par exemple avec quelques minutes pour {fajr} sous Décalage par prière, ou importez l’horaire de votre mosquée.',
        /** Korte zin bij de tijden (Vandaag, tablet) in de zomerweken van eu_joint. */
        methodTune: 'Horaires d’été : votre mosquée peut différer de quelques minutes. Ajustez selon votre mosquée.',
        /** Opnamebibliotheek (golf 6b, DESIGN §8.GB.15). */
        library: {
            intro: 'Choisissez un enregistrement par région. Écoutez d’abord : ce sont de vrais enregistrements, parfois avec des bruits de ville ou des oiseaux.',
            regions: {
                arabic: 'Style arabe',
                hijaz: 'La Mecque (Hedjaz)',
                turkish: 'Istanbul et Turquie',
                maghreb: 'Maroc',
                egypt: 'Égypte',
                levant: 'Jordanie',
                southeast_asia: 'Malaisie',
                central_asia: 'Kazakhstan',
                europe: 'Europe',
                other: 'Autres (lieu inconnu)',
            },
            places: {
                mecca: 'La Mecque, Masjid al-Haram',
                istanbul: 'Istanbul (court)',
                istanbul_fatih: 'Istanbul, mosquée Kalenderhane',
                mardin: 'Mardin, matin',
                patara: 'Patara, village, matin',
                casablanca: 'Casablanca, mosquée Hassan II',
                marrakech: 'Marrakech, Jemaa el-Fna',
                marrakech_medina: 'Marrakech, médina, matin',
                quseir: 'El Quseir, au bord de la mer',
                amman: 'Amman, matin',
                kuala_lumpur: 'Kuala Lumpur, matin',
                shalqar: 'Chalkar',
                malmo: 'Malmö, matin',
                indoor: 'Vendredi, enregistré à l’intérieur',
            },
            option: '{place} ({year})',
            meta: '{author} · {license} · {duration}',
            fajrTitle: 'Enregistrement pour {fajr}',
            fajrBody: '{fajr} a son propre appel, avec « as-salatu khayrun min an-nawm ». Choisissez un enregistrement du matin ou importez le vôtre ; sinon, la clochette sonne à {fajr}.',
            fajrNone: 'Aucun (la clochette)',
            fajrUnverified: 'enregistrement du matin, phrase du matin pas encore vérifiée',
            sources: 'Sources et licences',
            sourcesIntro: 'Tous les enregistrements sont libres d’utilisation. Pour chacun : le titre, l’auteur, la source et la licence. Nous avons retiré le silence au début et à la fin, égalisé le volume et converti en AAC.',
            by: '« {title} » par {author}, via {platform}',
            shareAlike: 'Notre version modifiée est aussi sous {license}.',
            report: 'Une source est incorrecte ? Écrivez-nous à support@amumin.com et nous retirerons l’enregistrement.',
        },
        audio: {
            builtin_a: '{callTitle}, style arabe',
            builtin_b: '{callTitle}, style arabe (plus court)',
            sunniNote: 'Ces enregistrements ont le texte sunnite.',
            shiaNote: 'Nos enregistrements ont le texte sunnite. Choisis la sonnerie ou ton propre enregistrement.',
            tone: 'Sonnerie douce (un son à part, différent des sonneries des tâches)',
            own: 'Importer ton propre enregistrement (m4a ou mp3, 5 minutes au maximum)',
            ownFajr: 'Enregistrement propre pour {fajr}',
            credits: 'À propos des enregistrements',
        },
        kidsMayStop: 'Les enfants peuvent arrêter l’{call}',
        kidsMayStopHint: 'Désactivé : le bouton Stop se trouve dans les commandes des parents.',
        device: {
            title: 'Sur quelles tablettes ?',
            sound: '{callTitle} : activer le son',
            soundAny: 'Son à l’heure de la prière',
            line: 'Prochaine prière en haut',
            card: 'Carte à l’heure de la prière',
            cardNight: 'Dans une chambre, jamais de carte la nuit.',
            volume: 'Volume',
            volumeIos: 'Sur un iPad, règle le volume avec les boutons sur le côté.',
            test: 'Tester sur la tablette',
            locked: '{name} : le son est coupé. Touche une fois l’écran de cette tablette.',
            unsupported: '{name} : cette tablette ne peut pas jouer de son.',
            outcome: {
                played: 'Entendu à {time}',
                card_locked: 'Silence à {time} : le son était coupé',
                card_late: 'Silence à {time} : vu trop tard',
                load_failed: 'Silence à {time} : enregistrement non chargé',
                skipped: 'Sauté à {time}',
            },
            checklist: 'Laisse l’écran allumé (Verrouillage automatique : Jamais). Dans Accès guidé : bouton latéral désactivé, boutons de volume activés. Ne mets pas l’iPad en veille avec le bouton latéral : sinon {isha} et {fajr} restent silencieux.',
        },
        kiosk: {
            next: '{name} {time}',
            nextIn: '{name} {time} · dans {left}',
            inMinutes: 'dans {n} min',
            inHours: 'dans {n} h',
            now: 'Maintenant : {name}',
            cardTitle: 'C’est l’heure de prier : {name}',
            playing: '{callTitle} en cours',
            playingChime: 'La sonnerie retentit',
            cardStop: 'Stop',
            cardStopHold: 'Garde le doigt pour arrêter',
            cardClose: 'Fermer',
            soundLocked: 'Touche pour le son',
            soundLockedLong: 'Le son est coupé. Touche pour l’activer.',
            unsupported: 'Cette tablette ne peut pas jouer de son',
            unknown: 'Heures de prière inconnues pour l’instant',
        },
        question: {
            title: 'Les heures de prière sur le tableau ?',
            body: 'La prochaine prière s’affiche alors en haut du tableau, et à l’heure de chaque prière, l’{call} retentit sur la tablette du salon.',
            body2: '{fajr} est silencieux par défaut. Tu peux tout modifier plus tard.',
            yes: 'Oui, volontiers',
            no: 'Non, pas maintenant',
            declined: 'Tu peux l’activer plus tard dans Réglages > Heures de prière.',
            placeTitle: 'Où habite ta famille ?',
            placeBody: 'Nous calculons alors les heures pour ta région. Un code postal ou une ville suffit ; nous gardons seulement une zone d’environ un kilomètre.',
            placeOther: 'Hors des Pays-Bas, ou une tablette ailleurs ? Règle-le dans Réglages > Lieu.',
            placeSave: 'Utiliser cet endroit',
            placeChosen: 'Heures pour {label}',
            /** Golf 6c: waarom deze methode (de mazhab, nooit de keuken). */
            methodMadhab: 'Nous calculons avec {method}, car vous suivez l’école hanafite.',
            methodDefault: 'Nous calculons avec {method}.',
            change: 'Modifier',
            methodChoose: 'Méthode de calcul',
            becauseOne: 'Car {name} suit l’islam.',
            becauseMany: 'Car {names} suivent l’islam.',
            next: 'Continuer',
            done: 'Fini',
            enabled: 'La prochaine prière s’affiche maintenant sur le tableau.',
            renew: 'Donner mon consentement et activer',
            off: 'Les heures de prière sont désactivées. Le tableau ne les affiche pas et rien ne retentit.',
            turnOn: 'Activer les heures de prière',
            offBody: 'Envie d’une pause ? Les heures disparaissent alors du tableau et rien ne retentit. Tes choix de méthode et de son sont gardés ; si la météo est aussi désactivée, nous effaçons le lieu.',
            turnOff: 'Désactiver les heures de prière',
            turnOffConfirm: 'Désactiver les heures de prière ? Tu peux toujours les réactiver ici.',
            turnOffYes: 'Oui, désactiver',
            turnOffCancel: 'Finalement non',
            renewOnly: 'Donner mon consentement',
            renewBody: 'L’explication de « Ce qui convient à notre famille » a changé : elle mentionne maintenant aussi des éléments en plus sur le tableau, comme ces heures de prière. Donne ici à nouveau ton consentement pour continuer à les utiliser.',
        },
        web: {
            consentRenewal: 'L’explication de « Ce qui convient à notre famille » a changé : elle mentionne maintenant aussi des éléments en plus sur le tableau, comme ces heures de prière. Donne d’abord à nouveau ton consentement là-bas.',
            consentLink: 'Aller à Ce qui convient à notre famille',
            locationLink: 'Choisir un lieu',
            save: 'Enregistrer',
            saved: 'Enregistré',
            today: 'Aujourd’hui, {place}',
            ourTime: 'calculé',
            offset: 'décalage',
            month: 'Mois',
            tableDays: {
                one: '{count} jour du calendrier de ta mosquée',
                other: '{count} jours du calendrier de ta mosquée',
            },
            tablePlaceholder: '2026-10-01;05:40;07:30;13:35;16:45;19:15;20:50',
            listen: 'Écouter',
            /** Tijdens het afspelen (review g6b ux r1: een stopknop, geen luidspreker met streep). */
            listenStop: 'Arrêter',
            listenPlaying: 'En lecture',
            upload: 'Choisir un fichier',
            uploaded: 'Enregistrement personnel utilisé',
            uploadFailed: 'Seulement un fichier m4a ou mp3 de 5 minutes et 5 Mo au maximum.',
            last: 'Dernière fois : {items}',
            testPending: 'Test envoyé. Le résultat s’affiche ici d’ici une minute.',
            uploadCall: 'Importer ton propre enregistrement de l’{call}',
            testResult: {
                played: 'Entendu',
                card_locked: 'Silence : le son était coupé',
                load_failed: 'Silence : enregistrement non chargé',
                skipped: 'Sauté',
            },
            volume: 'Volume (Android, Fully Kiosk)',
            noTablets: 'Aucune tablette associée pour l’instant.',
            credits: {
                builtin: '{callTitle}, style arabe : « {title} » de {author}, sur',
                license: 'CC0 1.0 (domaine public)',
                processing: 'Nous avons converti l’enregistrement en AAC et MP3 (mono) et l’avons mis au même volume que la sonnerie. Rien d’autre n’a été modifié.',
                tone: 'La sonnerie douce est un son créé par AMUMIN.',
            },
        },
        attribution: 'Heures de prière : calcul maison · méthode {method}',
        attributionTable: 'Heures de prière : calendrier de ta mosquée',
        hijri: {
            months: [
                'Mouharram',
                'Safar',
                'Rabia al-Awal',
                'Rabia ath-Thani',
                'Joumada al-Oula',
                'Joumada ath-Thania',
                'Rajab',
                'Chaabane',
                'Ramadan',
                'Chawwal',
                'Dhou al-Qi’da',
                'Dhou al-Hijja',
            ],
            pattern: '{day} {month} {year} AH',
        },
    },
};
//# sourceMappingURL=weatherPrayer.fr.js.map